import React, { useEffect, useState, useMemo } from 'react';
/* global axios */
import api from '../services/apiService';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Select from 'react-select'; // Neu: react-select importieren

const SubscriptionList = () => {
  const [subscriptions, setSubscriptions] = useState([]);
  // invoiceStates speichert für jede Subscription (subscriptionId) den Status:
  // "none" = keine Rechnung, "partial" = Teilrechnung(en) existieren, "final" = finale Rechnung erstellt

  const navigate = useNavigate();
  const [serverFilterOptions, setServerFilterOptions] = useState({
    subscriptionNumbers: [],
    referenceNumbers: [],
    customers: [],
    contacts: [],
    startDates: [],
    statuses: [],
  });
  

  // Filter-State initialisieren (aus Local Storage oder Default)
  const [filters, setFilters] = useState(() => {
    const storedFilters = localStorage.getItem('subscriptionListFilters');
    return storedFilters
      ? JSON.parse(storedFilters)
      : {
          subscriptionNumber: null,
          referenceNumber: null,
          customer: null,
          contact: null,
          startDate: null,
          status: null,
        };
  });
  
  useEffect(() => {
    localStorage.setItem('subscriptionListFilters', JSON.stringify(filters));
  }, [filters]);

  
  

   // Filteroptionen vom Backend laden
   useEffect(() => {
    const fetchFilterOptions = async () => {
      try {
        const response = await api.get('/subscriptions/filter-options');
        setServerFilterOptions(response.data);
      } catch (error) {
        console.error('Fehler beim Laden der Filteroptionen:', error);
      }
    };
    fetchFilterOptions();
  }, []);

   // Pagination

  const [currentPage, setCurrentPage] = useState(1);
  const limit = 25;
  const [totalPages, setTotalPages] = useState(1);

  // Query-String basierend auf Filter- und Pagination-Parametern (analog zur WorkshopOrderList)
  const buildQuery = () => {
    const params = new URLSearchParams();
    params.append('limit', limit);
    params.append('page', currentPage);
    if (filters.subscriptionNumber) {
      params.append('subscriptionNumber', filters.subscriptionNumber.value);
    }
    if (filters.referenceNumber) {
      params.append('referenceNumber', filters.referenceNumber.value);
    }
    if (filters.customer) {
      params.append('customer', filters.customer.value);
    }
    if (filters.contact) {
      params.append('contact', filters.contact.value);
    }
    if (filters.startDate) {
      params.append('startDate', filters.startDate.value);
    }
    if (filters.status) {
      params.append('status', filters.status.value);
    }
    return params.toString() ? `?${params.toString()}` : '';
  };

// Subscriptions serverseitig laden (mit Filter und Pagination)
useEffect(() => {
  const fetchSubscriptions = async () => {
    try {
      const query = buildQuery();
      const response = await api.get(`/subscriptions/list${query}`);
      // Erwartetes Response-Format: { total, page, pages, data: [...] }
      setSubscriptions(response.data.data);
      setTotalPages(response.data.pages);
    } catch (error) {
      console.error("Fehler beim Abrufen der Subscriptions:", error);
    }
  };
  fetchSubscriptions();
}, [filters, currentPage]);



  // Hilfsfunktion zur Formatierung von Datumsangaben
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
  };

  // Optionen für die Select-Komponenten aus den geladenen Filteroptionen
  const optionsSubscriptionNumber = serverFilterOptions.subscriptionNumbers.map(val => ({ value: val, label: val }));
  const optionsReferenceNumber = serverFilterOptions.referenceNumbers.map(val => ({ value: val, label: val }));
  const optionsCustomer = serverFilterOptions.customers.map(val => ({ value: val, label: val }));
  const optionsContact = serverFilterOptions.contacts.map(val => ({ value: val, label: val }));
  const optionsStartDate = serverFilterOptions.startDates.map(val => ({ value: val, label: val }));
  const optionsStatus = serverFilterOptions.statuses.map(val => ({ value: val, label: val }));

  const handleViewPDF = (subscriptionId) => {
    const pdfUrl = `${api.defaults.baseURL}/documents/subscription/${subscriptionId}/pdf`;
    window.open(pdfUrl, '_blank');
  };

  

    

  // Subscription löschen
  const deleteSubscription = (id) => {
    if (window.confirm('Möchten Sie diese Subscription wirklich löschen?')) {
      api.delete(`/subscriptions/${id}`)
        .then(() => {
          setSubscriptions(prev => prev.filter(sub => sub.id !== id));
          alert('Subscription erfolgreich gelöscht!');
        })
        .catch(error => console.error('Fehler beim Löschen der Subscription:', error));
    }
  };

  // Funktion zum Erstellen eines Draft-Subscriptions
  const createDraftSubscription = async () => {
    try {
      // Erweitere den Payload um alle erforderlichen Felder,
      // die auch im Backend für einen Entwurf benötigt werden.
      const payload = { 
        customerId: 1, 
        startDate: new Date().toISOString(), // aktuelles Datum als ISO-String
        frequencyQuantity: 1, 
        frequencyPoint: 'month',
        status: 'draft',
        // Optional: endDate, notes, etc. je nach Backend-Anforderungen
        endDate: null,
        notes: ''
      };
      const response = await api.post('/subscriptions/draft', payload);
      const { editUrl } = response.data;
      navigate(editUrl);
    } catch (error) {
      console.error('Fehler beim Erstellen eines Subscription-Entwurfs:', error);
      alert('Fehler beim Erstellen des Subscription-Entwurfs!');
    }
  };

  

  // Hilfsfunktion: Subscription per Mail versenden
  const sendSubscriptionMail = async (subscriptionId) => {
    try {
      await api.post(`/documents/subscription/${subscriptionId}/mail`);
      alert('Subscription wurde erfolgreich gemailt!');
    } catch (error) {
      console.error('Fehler beim Mailen der Subscription:', error);
      alert('Fehler beim Mailen der Subscription!');
    }
  };

  // Pagination-Komponente (Blätterfunktion) am Ende
  const pagination = (
    <div style={{ marginTop: '1rem', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
      <button
        onClick={() => setCurrentPage(currentPage > 1 ? currentPage - 1 : 1)}
        disabled={currentPage === 1}
        style={{ padding: '8px 12px' }}
      >
        Vorherige
      </button>
      <span>
        Seite {currentPage} von {totalPages}
      </span>
      <button
        onClick={() => setCurrentPage(currentPage < totalPages ? currentPage + 1 : totalPages)}
        disabled={currentPage === totalPages}
        style={{ padding: '8px 12px' }}
      >
        Nächste
      </button>
    </div>
  );

  return (
    <div className="subscription-list">
      <Helmet>
        <title>Subscriptionliste</title>
        <meta name="description" content="Subscriptionliste" />
      </Helmet>
      <h1>Subscriptions</h1>

      {/* Button zum Erstellen einer neuen Subscription */}
      <button 
        onClick={createDraftSubscription}
        style={{ marginBottom: '20px' }}
      >
        Neue Subscription erstellen
      </button>

     {/* Filterleiste */}
     <div style={{ marginBottom: '20px' }}>
        <h3>Filter</h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: '10px' }}>
          <Select
            options={optionsSubscriptionNumber}
            placeholder="Subscriptionnummer"
            isClearable
            value={filters.subscriptionNumber}
            onChange={(selected) => setFilters({ ...filters, subscriptionNumber: selected })}
          />
          <Select
            options={optionsReferenceNumber}
            placeholder="Referenz"
            isClearable
            value={filters.referenceNumber}
            onChange={(selected) => setFilters({ ...filters, referenceNumber: selected })}
          />
          <Select
            options={optionsCustomer}
            placeholder="Kunde"
            isClearable
            value={filters.customer}
            onChange={(selected) => setFilters({ ...filters, customer: selected })}
          />
          <Select
            options={optionsContact}
            placeholder="Besteller"
            isClearable
            value={filters.contact}
            onChange={(selected) => setFilters({ ...filters, contact: selected })}
          />
          <Select
            options={optionsStartDate}
            placeholder="Startdatum"
            isClearable
            value={filters.startDate}
            onChange={(selected) => setFilters({ ...filters, startDate: selected })}
          />
          <Select
            options={optionsStatus}
            placeholder="Status"
            isClearable
            value={filters.status}
            onChange={(selected) => setFilters({ ...filters, status: selected })}
          />
        </div>
      </div>


      {subscriptions.length > 0 ? (
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Subscriptionnummer</th>
              <th>Referenz</th>
              <th>Kunde</th>
              <th>Besteller</th>
              <th>Startdatum</th>
              <th>Nächste Fälligkeit</th>
              <th>Status</th>
              <th>Gesamt netto (€)</th>
              <th>Aktionen</th>
              
              
            </tr>
          </thead>
          <tbody>
          {subscriptions.map(sub => (
    <tr key={sub.id}>
      <td>{sub.id}</td>
      <td>{sub.subscriptionNumber}</td>
      <td>{sub.referenceNumber || '-'}</td>
      <td>
        {sub.customer?.company ||
          `${sub.customer?.firstName || ''} ${sub.customer?.lastName || ''}` ||
          'Unbekannt'}
      </td>
      <td>
      {sub.contact
        ? `${sub.contact.contactFirstName} ${sub.contact.contactLastName}`
        : ''}
      </td>
      <td>{formatDate(sub.startDate)}</td>
      <td>{formatDate(sub.nextDueDate)}</td>
      <td>{sub.status}</td>
      <td>{sub.totalNet?.toFixed(2).replace('.', ',')} €</td>
      {/* Aktionen: Bearbeiten & Löschen */}
      <td>
        <div style={{ display: 'flex', gap: '5px' }}>
          <button
            type="button"
            onClick={() => navigate(`/subscriptions/${sub.id}/edit`)}
            style={{
              fontSize: '15px',
              padding: '5px 10px',
              background: '#007bff',
              color: '#fff',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer'
            }}
          >
            Bearbeiten
          </button>
          <button
            type="button"
            onClick={() => deleteSubscription(sub.id)}
            style={{
              fontSize: '15px',
              padding: '5px 10px',
              background: '#dc3545',
              color: '#fff',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer'
            }}
          >
            Löschen
          </button>
        </div>
      </td>
      
    </tr>
  ))}
</tbody>
        </table>
        
      ) : (
        <p>Keine Subscriptions verfügbar.</p>
      )}
      <div style={{ marginTop: '1rem', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
  <button
    onClick={() => setCurrentPage(currentPage > 1 ? currentPage - 1 : 1)}
    disabled={currentPage === 1}
    style={{
      fontSize: '15px',
      padding: '8px 12px',
      backgroundColor:'rgb(155, 155, 155)',
      border: 'none',
      borderRadius: '5px',
      cursor: 'pointer'
    }} 
  >
    Vorherige
  </button>

  {/* Anzeige der aktuellen Seite */}
  <span>
    Seite {currentPage} von {totalPages}
  </span>

  <button
    onClick={() => setCurrentPage(currentPage < totalPages ? currentPage + 1 : totalPages)}
    disabled={currentPage === totalPages}
    style={{
      fontSize: '15px',
      padding: '8px 12px',
      backgroundColor:'rgb(155, 155, 155)',
      border: 'none',
      borderRadius: '5px',
      cursor: 'pointer'
    }} 
  >
    Nächste
  </button>
</div>

      
    </div>
  );
};

export default SubscriptionList;
